import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { foCaAnApi } from "../../../api/dich-vu/food/foCaAnApi";
import { foMonAnChiTietApi } from "../../../api/dich-vu/food/foMonAnChiTietApi";
import { foThucDonApi } from "../../../api/dich-vu/food/foThucDonApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eFoThucDonActionTypeIds,
	IFoThucDonImportStart,
	IFoThucDonLoadMonAnStart,
	IFoThucDonLoadStart,
	IFoThucDonSaveMultipleStart,
	IFoThucDonValidateImportStart
} from "../../action-types/dich-vu/IFoThucDonActionTypes";
import { foThucDonActions } from "../../actions/dich-vu/foThucDonActions";

export function* foThucDonSaga(): any {
	yield takeLatest(eFoThucDonActionTypeIds.LOAD_START, loadFoThucDonWorker)
	yield takeLatest(eFoThucDonActionTypeIds.LOAD_CAAN_START, loadFoCaAnWorker)
	yield takeLatest(eFoThucDonActionTypeIds.LOAD_MONAN_START, loadFoMonAnChiTietWorker)
	yield takeEvery(eFoThucDonActionTypeIds.SAVE_MULTIPLE_START, saveFoThucDonMultipleWorker)
	yield takeEvery(eFoThucDonActionTypeIds.VALIDATE_IMPORT_START, validateImportFoThucDonWorker)
	yield takeEvery(eFoThucDonActionTypeIds.IMPORT_START, importFoThucDonWorker)
}

function* loadFoThucDonWorker(action: IFoThucDonLoadStart): any {
	const res: IBaseResponeModel = yield call([foThucDonApi, foThucDonApi.SelectDetailDayByDay], action.payload)
	if (res.is_success) {
		yield put(foThucDonActions.loadFoThucDonSuccess(res.data))
	} else {
		yield put(foThucDonActions.loadFoThucDonError(res.message || "Không tải được thực đơn"))
	}
}

function* loadFoCaAnWorker(): any {
	const res: IBaseResponeModel = yield call([foCaAnApi, foCaAnApi.SelectAll])
	if (res.is_success) {
		yield put(foThucDonActions.loadFoCaAnSuccess(res.data || []))
	} else {
		yield put(foThucDonActions.loadFoCaAnError(res.message || "Không tải được danh sách ca ăn"))
	}
}

function* loadFoMonAnChiTietWorker(action: IFoThucDonLoadMonAnStart): any {
	const res: IBaseResponeModel = yield call([foMonAnChiTietApi, foMonAnChiTietApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(foThucDonActions.loadFoMonAnChiTietSuccess(res.data || []))
	} else {
		yield put(foThucDonActions.loadFoMonAnChiTietError(res.message || "Không tải được danh sách món ăn"))
	}
}

function* saveFoThucDonMultipleWorker(action: IFoThucDonSaveMultipleStart): any {
	const res: IBaseResponeModel = yield call([foThucDonApi, foThucDonApi.InsertMultiple], action.payload)
	if (res.is_success) {
		yield put(foThucDonActions.saveFoThucDonMultipleSuccess())
	} else {
		yield put(foThucDonActions.saveFoThucDonMultipleError(res.message || "Không lưu được thực đơn"))
	}
}

function* validateImportFoThucDonWorker(action: IFoThucDonValidateImportStart): any {
	const res: IBaseResponeModel = yield call([foThucDonApi, foThucDonApi.ValidateImport], action.payload)
	if (res.is_success) {
		yield put(foThucDonActions.validateImportFoThucDonSuccess(res.data || []))
	} else {
		yield put(foThucDonActions.validateImportFoThucDonError(res.message || "Có lỗi"))
	}
}

function* importFoThucDonWorker(action: IFoThucDonImportStart): any {
	const res: IBaseResponeModel = yield call([foThucDonApi, foThucDonApi.Import], action.payload)
	if (res.is_success) {
		yield put(foThucDonActions.importFoThucDonSuccess())
	} else {
		yield put(foThucDonActions.importFoThucDonError(res.message || "Có lỗi"))
	}
}
